import request from '@/utils/request';

export function getUserSystem() {
  return request({
    url: '/system/userCommon/sys',
    method: 'get'
  })
}

export function getUserInfo() {
  return request({
    url: '/system/userCommon/info',
    method: 'get'
  })
}
export function getJwt() { // 获取jwt
  return request({
    url: '/debug/jwt/4',
    method: 'get'
  })
}

export function getSearchSchool(data) { // 查找学校
  return request({
    url: '/system/ext/university/search/school',
    method: 'POST',
    data
  })
}

export function getSearchCollege(data) { // 根据学校搜索院系专业
  return request({
    url: '/system/ext/university/search/college',
    method: 'POST',
    data
  })
}

export function getSearchOption() { // 查找学校属性
  return request({
    url: '/system/ext/university/search/option',
    method: 'GET'
  })
}


export function getCorrigendum(id) { //查询勘误码
  return request({
    url: `/market/ext/materialList/corrigendum/${id}`,
    method: 'GET'
  })
}

export function suggestionApi(data, systemId) { //添加意见
  return request({
    url: `/market/ext/materialList/suggestion`,
    method: 'put',
    data,
    responseType: 'blob',
    timeout: 30000,
    config: {
      count: true,
      SystemId: systemId
    }
  })
}
export function commonCascade(callIndex, systemId) {
  return request({
    url: `/order/ext/common/cascade/${callIndex}`,
    method: 'get',
    config: {
      SystemId: systemId
    }
  })
}


//添加次数
export function corrigendumCountApi(id, type, systemId) {
  return request({
    url: `/market/ext/materialList/corrigendum/count/${id}/${type}`,
    method: 'GET',
    config: {
      SystemId: systemId
    }
  })
}